
var func = function(el, binding, vnode) {
    var valor = binding.value;
    var scale = 1
    if(valor > 0){
        scale = valor
    }

    el.style.transform = `scale(${scale})`;

}

export default {
    bind: func,
    update: func
}